// extracted by mini-css-extract-plugin
export default {"root":"ErrorBoundary_root__WnnZZ"};